__turbopack_context__.v({
  "container": "Disclaimer-module__vlh3uq__container",
  "disclaimer": "Disclaimer-module__vlh3uq__disclaimer",
  "text": "Disclaimer-module__vlh3uq__text",
  "title": "Disclaimer-module__vlh3uq__title",
});
